<ngx-slider   id="formControlRange"
  [options]="options"
  [formControl]="control"
></ngx-slider>
